import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "../../data/site";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location]);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 bg-paper border-b transition-colors duration-300 ${scrolled ? "border-teal-anchor/15 shadow-[0_1px_20px_rgba(11,43,38,0.06)]" : "border-transparent"}`}
    >
      <div data-testid="promo-banner" className="bg-teal-anchor px-4 py-1.5 text-center text-[11px] font-semibold uppercase tracking-[0.18em] text-paper/90">
        First order? Get 10% off with code <span className="text-paper">WELCOME10</span>
      </div>
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" data-testid="nav-logo" className="flex items-baseline gap-2 group">
            <span className="font-serif text-2xl tracking-tight text-teal-anchor">Tanonshop</span>
            <span className="hidden sm:inline text-[10px] uppercase tracking-[0.25em] text-teal-primary/70 font-semibold">Custom Cushions</span>
          </Link>

          <nav className="hidden lg:flex items-center gap-9">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `text-sm font-medium link-underline ${isActive ? "text-teal-primary" : "text-teal-anchor/80 hover:text-teal-anchor"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <Link
              to="/custom-order"
              data-testid="nav-request-quote-btn"
              className="hidden sm:inline-flex items-center rounded-sm bg-teal-primary px-5 py-2.5 text-xs font-semibold uppercase tracking-[0.15em] text-paper transition-all duration-200 hover:bg-teal-hover hover:-translate-y-px focus:outline-none focus:ring-2 focus:ring-teal-primary focus:ring-offset-2 focus:ring-offset-paper"
            >
              Request a Quote
            </Link>
            <button
              data-testid="nav-mobile-toggle"
              className="lg:hidden p-2 text-teal-anchor"
              onClick={() => setOpen((o) => !o)}
              aria-label="Toggle menu"
            >
              {open ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="lg:hidden bg-paper border-t border-teal-anchor/10 px-5 py-6">
          <nav className="flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                className={({ isActive }) =>
                  `py-3 text-base font-medium border-b border-teal-anchor/5 ${isActive ? "text-teal-primary" : "text-teal-anchor"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/custom-order"
              className="mt-4 inline-flex justify-center rounded-sm bg-teal-primary px-5 py-3 text-xs font-semibold uppercase tracking-[0.15em] text-paper"
            >
              Request a Quote
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
